// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Edit Loan Documents'"></sub-header>

  <ng-form name="\$ctrl.editLoanDocumentsForm">
    <loan-documents loan="\$ctrl.loan"></loan-documents>
  </ng-form>

  <div class="summary-actions">
    <button ng-click="\$ctrl.cancel()" class="btn btn-warning">Cancel</button>
    <button ng-click="\$ctrl.update()" ng-disabled="\$ctrl.editLoanDocumentsForm.\$invalid" class="btn btn-success">Update</button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/documents/loan-edit-documents.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;